import { FormControl, FormField } from "@/components/ui/form";
import { ControllerRenderProps, FieldPath, FieldValues } from "react-hook-form";
import useBusy from "../hooks/useBusy";
import DataTableCellCheckbox from "@/components/data-table/components/DataTableCellCheckbox";
import DataTableCellInput from "@/components/data-table/components/DataTableCellInput";
import { memo } from "react";

interface FieldComponentProps {
  field: ControllerRenderProps<FieldValues, FieldPath<FieldValues>>;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  fieldType: string;
  isBusy: boolean;
}

interface DataTableCellFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  wrapperClassName?: string;
}

const FieldComponent = ({
  field,
  fieldType,
  isBusy,
  inputProps = {},
}: FieldComponentProps) => {
  switch (fieldType) {
    case "checkbox": {
      return (
        <DataTableCellCheckbox
          {...field}
          className={inputProps.className}
          disabled={isBusy || !!field.disabled}
        />
      );
    }
    case "input":
    case "number":
    default: {
      return (
        <DataTableCellInput
          type={fieldType}
          {...inputProps}
          {...field}
          disabled={isBusy || !!field.disabled}
        />
      );
    }
  }
};

const DataTableCellField = ({
  name,
  type = "input",
  ...props
}: DataTableCellFieldProps) => {
  const isBusy = useBusy();

  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormControl>
          <FieldComponent
            field={field}
            fieldType={type}
            isBusy={isBusy ?? false}
            inputProps={props}
          />
        </FormControl>
      )}
    />
  );
};

export default memo(DataTableCellField);
